import { TLocalization } from "../../apis/localization/localization.interfaces";

export const localizationListMock: TLocalization[] = [
  {
    id: "1",
    instituteId: "1",
    currency: "INR",
    language: "en",
    additionalLanguages: ["hi"],
    dateFormat: "DD/MM/YYYY",
    timeFormat: "12h",
    numberFormat: "en-IN",
  },
];

export const localizationMock: TLocalization = localizationListMock[0];
